export function creerClePreuve(action: "ASSOCIER" | "VALIDER" | "REFUSER", preuveId: string): string {
  const suffixe = globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  return `PHASE9-${action}-${preuveId}-${suffixe}`.slice(0, 200);
}

export function peutValiderPreuve(statut: string, expeditionId: string | null): boolean {
  return statut !== "LIVRAISON_VALIDEE" && statut !== "REFUSEE" && Boolean(expeditionId);
}

export function estReferenceSharePointSecuritaire(reference: string | null): boolean {
  if (!reference) return false;
  try {
    const url = new URL(reference);
    return url.protocol === "https:" && url.hostname.toLowerCase().endsWith(".sharepoint.com")
      && !url.username && !url.password && !url.hash;
  } catch {
    return false;
  }
}
